// =========================================================================================@@
// Last Updated Date: Feb 11, 2026
// Last Updated By: Steven Yuen
// Status Level: 2
// ===========================================================================================

import React, { useEffect, useRef } from 'react'
import { View } from 'oio-react'
import GA from 'react-ga4'
import Helmet from 'react-helmet'
import { DownloadGlyph12Icon } from 'assets/icons'
import HomeCoverVideo from 'src/sites/custom/gns3/Home/CoverVideo'
import { useOrganization } from 'src/core/graphql/hooks'
import { Button, Footer } from 'src/sites/kits/UI'
import HomeFeatures from 'src/sites/custom/gns3/Home/Features'
// import AdButlerBanner from 'src/sites/custom/gns3/Banners/AdButler'
// const homeAdIds = ['325994', '325997', '435275']

const customers = [
   {
      name: 'Google',
      image: 'google.png'
   },
   {
      name: 'Starbucks',
      image: 'starbucks.png'
   },
   {
      name: 'T-Systems',
      image: 'tsystems.png'
   },
   {
      name: 'NASA',
      image: 'nasa.png'
   },
   {
      name: 'Solarwinds',
      image: 'solarwinds.png'
   },
   {
      name: 'Pfizer',
      image: 'pfizer.png'
   }
]

const HomeLayout = () => {
   const viewRef = useRef()
   const { organization } = useOrganization()
   const memberRole = organization.roles.find(r => r.type === 'primary')
   const softwareVersion = organization.metadata.find(m => m.key === 'software_version')?.value
   const softwareDownloadCount = organization.metadata.find(m => m.key === 'software_download_count')?.value

   // const homeFeature1Data = organization.metadata
   //    .find(m => m.key === 'home_feature_1')?.value

   // const homeFeature2Data = organization.metadata
   //    .find(m => m.key === 'home_feature_2')?.value

   const handleAnalyticsClick = (action) => {
      if (organization.tmpGoogleAnalyticsTrackingId) {
         GA.event({
            category: 'Home',
            action: `Home - ${action}`
         })
      }
   }

   useEffect(() => {
      setTimeout(() => {
         document.body.classList.add('gather-transparent-header-menu')
      }, 0)

      return () => {
         document.body.classList.remove('gather-transparent-header-menu')
      }
   }, [])

   // const handleScroll = (event) => {
   //    if (event.currentTarget.scrollTop > 80) {
   //       document.body.classList.remove('gather-transparent-header-menu')
   //    } else {
   //       document.body.classList.add('gather-transparent-header-menu')
   //    }
   // }

   return (
      <View
         // onScroll={handleScroll}
         ref={viewRef}
         width="100%"
         height="100vh"
         scroll="on">
         <Helmet
            title={`${organization.name} | The software that empowers network professionals`}
         />
         <View
            position="relative"
            width="100%"
            minHeight="700px[a-b] 700px[c-f]"
            backgroundColor="#0a1d2d">
            <HomeCoverVideo />
            <View
               position="absolute"
               top="300px[a-c] 0px[d-f]"
               left="0px"
               right="0px[a-c] 50%[d-f]"
               bottom="0px"
               style={{
                  background:
                     'radial-gradient(circle, rgba(162, 7, 245, 0.7) 0%, rgba(0,0,0,0) 50%)'
               }}
            />
            <View
               display="flex"
               alignItems="center"
               flexFlow="column"
               position="absolute"
               top="0px"
               left="0px"
               paddingTop="80px"
               width="100%"
               height="100%"
               style={{
                  background:
                     'radial-gradient(circle, rgba(30, 44, 110, 0.6) 0%, rgba(0,0,0,1) 60%)'
               }}>
               <View
                  width="100%"
                  maxWidth="100%[a-b] 80%[c] 720px[d-f]"
                  padding="0px 30px[a-b] 30px[b-f]"
                  textAlign="center">
                  <View display="inline-block">
                     <img
                        src="/assets/custom/gns3/images/logo-colour.png"
                        alt="GNS3"
                        width="78px"
                     />
                  </View>
                  <div>
                     <div className="inline-block text-sm text-white/80 my-8 border border-solid border-white/30 rounded-full px-4 py-1">
                        {`Version ${softwareVersion} available`}
                     </div>
                  </div>
                  <div
                     className="text-4xl md:text-5xl font-semibold tracking-tighter my-2"
                     style={{
                        color: '#fff',
                        background: '-webkit-linear-gradient(#fff, rgba(255,255,255,0.7))',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent'
                     }}>
                     The software that empowers
                     <br />
                     network professionals
                  </div>
                  <div className="text-base md:text-lg mt-10 mb-10 font-[450] text-white/60">
                     {'Join the world\'s largest community of network professionals who rely on GNS3 to build better networks, share ideas and make connections.'}
                  </div>
                  <div className="text-base md:text-base flex flex-col md:flex-row gap-4 justify-center items-center">
                     <Button
                        width="200px"
                        height="56px"
                        onClick={() => handleAnalyticsClick('Download Click')}
                        linkTo="/software/download"
                        name="Free Download"
                        color="#58f06d"
                        textColor="#2c4820"
                        borderRadius="28px">
                        <View marginRight="12px">
                           <DownloadGlyph12Icon width="12px" height="12px" color="#2c4820" />
                        </View>
                     </Button>
                  </div>
                  {/* <Spacer size="6" /> */}
               </View>
            </View>
         </View>
         <HomeFeatures />
         <View
            width="100%"
            padding="30px 0px 60px 0px"
            backgroundColor="#15181C"
            textAlign="center">
            <View display="block" width="100%" padding="30px 24px">
               <div className="text-base text-white/50">
                  <span className="text-white" id="mo-download-count">
                     {softwareDownloadCount}
                  </span>
                  &nbsp; Downloads from &nbsp;
                  <span className="text-white" id="mo-community-member-count">
                     {parseInt(memberRole.numActiveUsers, 10).toLocaleString()}
                  </span>
                  &nbsp;network professionals worldwide
               </div>
            </View>
            <View display="flex" flexFlow="row wrap" justifyContent="center" maxWidth="100%">
               {customers.map(customer => (
                  <View
                     key={customer.name}
                     display="inline-flex"
                     justifyContent="center"
                     alignItems="center"
                     height="90px"
                     margin="0px 20px"
                     opacity="0.6">
                     <img
                        src={`/assets/custom/gns3/images/home/${customer.image}`}
                        alt={customer.name}
                        height="48px"
                     />
                  </View>
               ))}
            </View>
         </View>
         <Footer />
      </View>
   )
}

export default HomeLayout
